var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgP8(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 25,
    viewBox: "0 0 24 25",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M8.5 15.1667C8.5 16.4553 9.54467 17.5 10.8333 17.5H13C14.3807 17.5 15.5 16.3807 15.5 15C15.5 13.6193 14.3807 12.5 13 12.5H11C9.61929 12.5 8.5 11.3807 8.5 10C8.5 8.61929 9.61929 7.5 11 7.5H13.1667C14.4553 7.5 15.5 8.54467 15.5 9.83333M12 6V7.5M12 17.5V19M22 12.5C22 18.0228 17.5228 22.5 12 22.5C6.47715 22.5 2 18.0228 2 12.5C2 6.97715 6.47715 2.5 12 2.5C17.5228 2.5 22 6.97715 22 12.5Z",
    stroke: "#256BFD",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgP8);
export default __webpack_public_path__ + "static/media/p8.25e558b5ee337540969323b68653336d.svg";
export { ForwardRef as ReactComponent };